import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'relay-runtime';
import { environment } from '../../Environment';

export const query = graphql`
  query UsersQuery {
    me {
      id
      firstName
      lastName
      email
      locale
      subscription {
        id
        status
        cancelAtPeriodEnd
        currentPeriodEnd
        planName
        errorMessage
      }
    }
  }
`;

const fetch = params => fetchQuery(environment, query, params).toPromise();

export default { fetch };
